import { useEffect, useRef, useState } from "react";
import { LuChevronLeft, LuX } from "react-icons/lu";
import { useIsUserSignedIn } from "../../../core_stores/useAuthStore";
import { useIsCompactView } from "../../../core_stores/useIsCompactViewStore";
import { colors, components, effects } from "../../../design/tokens";

export default function SubscriptionsModalLayout({
  children,
  onClose,
}: {
  children: React.ReactNode;
  onClose?: () => void;
}) {
  const isUserSignedIn = useIsUserSignedIn();

  const [isVisible, setIsVisible] = useState(false);
  const isCompactView = useIsCompactView();
  const closeTimeout = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setIsVisible(true);
    return () => {
      if (closeTimeout.current) clearTimeout(closeTimeout.current);
    };
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    closeTimeout.current = setTimeout(() => {
      onClose?.();
    }, 200); // match transition duration
  };

  return (
    <div
      className={`${
        isVisible ? "opacity-100" : "opacity-0 pointer-events-none"
      } ${!isCompactView && "p-4"} fixed inset-0 z-50
      flex items-center justify-center
      transition-opacity duration-300
      ${components.modal.overlay}`}
      onClick={(e) => {
        if (!isCompactView && e.target === e.currentTarget) {
          handleClose();
        }
      }}
    >
      <div
        className={`${
          !isCompactView &&
          `max-w-[1200px] rounded-md ${
            isUserSignedIn ? "max-h-[625px]" : "max-h-[515px]"
          }`
        }
          relative
      w-full h-full
      flex flex-col overflow-hidden
      border ${colors.border.gray[800]}`}
        style={{
          backgroundColor: colors.hex.surfaceSecondary,
          boxShadow: effects.shadow.custom.modal
        }}
      >

        {children}

        <button
          className={`${isCompactView ? "left-4" : "right-4"}
            absolute top-4 z-50
          ${components.modal.closeButton} text-2xl`}
          onClick={handleClose}
          aria-label="Close"
        >
          {isCompactView ? <LuChevronLeft size={24} /> : <LuX size={24} />}
        </button>
      </div>
    </div>
  );
}
